import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'campaigns/';

export default {
  getUnmapped: () => {
    return api.get(`${BASE_URL}unmapped`);
  },
  getMapped: () => {
    return api.get(`${BASE_URL}mapped`);
  },
  getAutomapped: () => {
    return api.get(`${BASE_URL}automapped`);
  }
};
